<template>
    <section class="site_banner">
        <h2 class="site_banner--title text-center">
            <img src="/netemosametemo/static/img/main_tittle_white_img.png" alt="Sign">
            <strong class="seo"></strong>
        </h2>

        <div class="grid-container">
            <ul class="grid-x grid-padding-x align-center align-stretch">
                <li class="cell small-12 medium-10 large-6">
                    <article class="site_banner--article">
                        <h3 class="site_banner--article--title"> [オリジナルポストカード]付
                            <br>ムビチケカード１５００円<small>（税込）</small>発売中！
                            <br><small>＜当日一般１８００円の処＞ ※数量限定 ※一部劇場除く</small>
                        </h3>
                        <figure class="site_banner--article--image">
                            <img src="/netemosametemo/static/img/netesame_post_img.jpg" alt="オリジナルポストカード">
                        </figure>
                    </article>
                </li>

                <li class="site_banner--link--holder cell small-12 medium-10 large-4">
                    <a href="https://www.major-j.com/info.php?f=M20180526002netemosametemo" title="WEB購入はこちら" class="site_banner--link" target="_blank"><strong>WEB購入はこちら</strong></a>
                </li>

                <li class="cell small-12 large-11">
                    <section class="site_banner--description">
                        <h3 class="site_banner--description--title">バリアフリー上映のご案内<a href="http://udcast.net/" target="_blank" title="UDCast"><img src="/netemosametemo/static/img/udcast.png" alt="UDCast"></a></h3>
                        <ul class="site_banner--description--content">
                            <li>本作品は『UDCast』方式に対応した視覚障害者用音声ガイドに対応しています。</li>
                            <li>音声ガイドをご希望の方は専用アプリから音声ガイドデータをダウンロードしていただければ、全ての上映劇場、上映回でご利用いただけます。</li>
                            <li>一部Android端末には『UDCast』アプリに未対応の機種がありますので、事前に動作確認をお願いします。</li>
                            <li>『UDCast』の詳しい説明、及び動作確認はこちら（<a href="http://udcast.net/" target="_blank" class="link" title="UDCast">http://udcast.net/</a>）まで</li>
                        </ul>
                    </section>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    name: 'site-banner',
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Sitebanner.vue